import BaseComponents from '@components/global-install.js'

export function useComponents (app) {
  app.use(BaseComponents)
}